import React from 'react';

export default () => (
	<header className="app-header">
		<span>Page not found</span>
	</header>
)
